module.exports = __webpack_public_path__ + "efa2d06775d9f18f542c2d23eae60b65.fbx";